export const DialogSummaryItemName = 'dialogSummaryItemComponent';
